export enum Currency {
    MY = "RM",
}